import React from 'react';

const TabButton = ({ active, icon: Icon, label, onClick }) => (
  <button
    onClick={onClick}
    className={`flex flex-col items-center justify-center w-full py-3 transition-colors ${
      active
        ? 'text-green-500 border-t-2 border-green-500 bg-gray-900'
        : 'text-gray-500 hover:text-gray-300 bg-black'
    }`}
  >
    <Icon size={20} className="mb-1" />
    <span className="text-[10px] font-medium uppercase tracking-wide">{label}</span>
  </button>
);

export default TabButton;




